import { Card, Flex } from "antd";
import { map, maxBy } from "lodash";
import React from "react";
import { Column } from "@ant-design/plots";
import { useSelector } from "react-redux";
import AppInput from "../../../components/common/AppInput";
import AppButton from "../../../components/common/AppButton";

const TimeSheetDashboard = () => {
  const { dashboardData: data } = useSelector((state) => state.dashboardState);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const timeSheetData = map(data.timeSheetData?.monthlyWorkload, (item) => {
    const month = months[item.month];

    return {
      month,
      totalHours: item.totalHours,
    };
  });

  const maxHours = maxBy(timeSheetData, "totalHours")?.totalHours || 0;

  //   console.log

  const config = {
    data: timeSheetData,
    xField: "month",
    yField: "totalHours",
    markBackground: {
      style: {
        fill: "#eee",
      },
    },
    scale: {
      y: {
        domain: [0, maxHours + 10],
      },
    },
    legend: false,
  };

  return (
    <Card title="TIME SHEET MONTHLY SUMMARY " className="pb-4">
      <Flex gap={4} align="center" justify="center" className="pt-3">
        <AppInput
        
          type="date"
          inputAttributes={{
            picker: "year",
            className: 'mt-1'
          }}
        />
        <AppButton 
         text="SUBMIT"
        />
      </Flex>
      <Column {...config} />
    </Card>
  );
};

export default TimeSheetDashboard;
